
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dijital-satis-kariyer-basvuru",
      function () {
        return require("private-next-pages/dijital-satis-kariyer-basvuru.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dijital-satis-kariyer-basvuru"])
      });
    }
  